/******/ (() => {
/* eslint-disable */
if (!customElements.get('info-columns-product-purchase')) {
  customElements.define(
    'info-columns-product-purchase',
    class InfoColumnsProductPurchase extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productUrl = this.dataset.productUrl || '';
        this.showFromPrefix = this.dataset.showFromPrefix === 'true';
        this.priceEl = this.querySelector('[data-info-cols-purchase-price]');
        this.comparePriceEl = this.querySelector('[data-info-cols-purchase-compare-price]');
        this.compareWrap = this.querySelector('[data-info-cols-purchase-compare-wrap]');
        this.ctaLink = this.querySelector('[data-info-cols-purchase-cta]');
        this.fromPrefixEl = this.querySelector('[data-info-cols-purchase-from]');

        const wethemeGlobal = document.querySelector('script#wetheme-global');
        if (wethemeGlobal) {
          try {
            this.moneyFormat = JSON.parse(wethemeGlobal.textContent).moneyFormat;
          } catch (e) {
            this.moneyFormat = '${{amount}}';
          }
        } else {
          this.moneyFormat = '${{amount}}';
        }

        eventBus.on('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        eventBus.off('variant:change', this.onVariantChange);
      }

      handleVariantChange(context) {
        if (context.sectionId !== this.sectionId) return;
        if (!context.variant) return;
        this.updateVariant(context.variant);
      }

      updateVariant(variant) {
        if (this.fromPrefixEl) {
          this.fromPrefixEl.setAttribute('hidden', '');
        }
        if (this.priceEl) {
          this.priceEl.textContent = this.formatVariantPrice(variant.price);
        }

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (this.compareWrap) {
          this.compareWrap.toggleAttribute('hidden', !onSale);
        }
        if (this.comparePriceEl && onSale) {
          this.comparePriceEl.textContent = this.formatVariantPrice(variant.compare_at_price);
        }

        if (this.ctaLink && this.productUrl) {
          this.ctaLink.setAttribute('href', `${this.productUrl}?variant=${variant.id}`);
        }
      }

      formatVariantPrice(cents) {
        if (window.wetheme?.formatMoney) {
          const formatted = window.wetheme.formatMoney(cents, this.moneyFormat);
          const tmp = document.createElement('div');
          tmp.innerHTML = formatted;
          return tmp.textContent || tmp.innerText;
        }
        return (cents / 100).toFixed(2);
      }
    }
  );
}
/******/ })();
